var app = angular.module('Fifth', [
	'ngMaterial',
	'duScroll'
])

.config(function($mdThemingProvider) {
  $mdThemingProvider.disableTheming();
});